import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lini-view-container" }
const _hoisted_2 = {
  key: 0,
  class: "doc-header-card"
}
const _hoisted_3 = { class: "doc-header-top" }
const _hoisted_4 = { class: "doc-header-main" }
const _hoisted_5 = { class: "doc-hdr-numar" }
const _hoisted_6 = { class: "doc-hdr-categorie-badge" }
const _hoisted_7 = { class: "doc-header-actions" }
const _hoisted_8 = { class: "doc-meta-strip" }
const _hoisted_9 = { class: "doc-meta-item doc-meta-item--partener" }
const _hoisted_10 = { class: "doc-meta-content" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "doc-meta-item" }
const _hoisted_13 = { class: "doc-meta-content" }
const _hoisted_14 = { class: "doc-meta-value" }
const _hoisted_15 = { class: "doc-meta-item" }
const _hoisted_16 = { class: "doc-meta-content" }
const _hoisted_17 = { class: "doc-meta-value" }
const _hoisted_18 = { class: "doc-meta-item" }
const _hoisted_19 = { class: "doc-meta-content" }
const _hoisted_20 = { class: "doc-meta-value" }
const _hoisted_21 = { class: "doc-meta-item" }
const _hoisted_22 = { class: "doc-meta-content" }
const _hoisted_23 = { class: "doc-meta-label" }
const _hoisted_24 = { class: "doc-meta-value" }
const _hoisted_25 = { class: "doc-cursuri-box" }
const _hoisted_26 = { class: "doc-cursuri-rows" }
const _hoisted_27 = {
  key: 0,
  class: "doc-curs-row"
}
const _hoisted_28 = { class: "doc-curs-valoare" }
const _hoisted_29 = {
  key: 1,
  class: "doc-curs-row"
}
const _hoisted_30 = { class: "doc-curs-valoare" }
const _hoisted_31 = {
  key: 3,
  class: "doc-totals-box"
}
const _hoisted_32 = {
  key: 0,
  class: "doc-totals-row"
}
const _hoisted_33 = { class: "doc-totals-value-secondary" }
const _hoisted_34 = {
  key: 1,
  class: "doc-totals-separator"
}
const _hoisted_35 = {
  key: 2,
  class: "doc-totals-row"
}
const _hoisted_36 = { class: "doc-totals-value-main" }
const _hoisted_37 = {
  key: 1,
  class: "grid-section"
}
const _hoisted_38 = {
  key: 2,
  class: "null-document-state"
}
const _hoisted_39 = { class: "form-footer footer-modern" }
const _hoisted_40 = { class: "footer-right" }
const _hoisted_41 = { class: "form-footer footer-modern" }
const _hoisted_42 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_GridDocumentLinii = _resolveComponent("GridDocumentLinii")!
  const _component_PopupEtichete = _resolveComponent("PopupEtichete")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxLoadPanel, {
      visible: _ctx.isPrinting,
      message: "Se generează PDF-ul...",
      "show-overlay": true,
      "show-pane": true
    }, null, 8, ["visible"]),
    (_ctx.document)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "dx-icon dx-icon-doc doc-hdr-icon" }, null, -1)),
              _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(_ctx.document.Numar), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.document.Categorie), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.document.ComandaID)
                ? (_openBlock(), _createBlock(_component_DxButton, {
                    key: 0,
                    text: "Preia din comandă",
                    icon: "import",
                    "styling-mode": "text",
                    disabled: _ctx.isPreluandProduse,
                    onClick: _ctx.onPreiaDinComanda
                  }, null, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.document.PartenerID && _ctx.document.ProiectID)
                ? (_openBlock(), _createBlock(_component_DxButton, {
                    key: 1,
                    text: "Preia din comenzile proiectului",
                    icon: "import",
                    "styling-mode": "text",
                    disabled: _ctx.isPreluandProduse,
                    onClick: _ctx.onDeschidePreiaDinComenziProiect
                  }, null, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.areDocumentTip)
                ? (_openBlock(), _createBlock(_component_DxButton, {
                    key: 2,
                    text: _ctx.document.Document ? `Document asociat: ${_ctx.document.Document}` : 'Document asociat',
                    icon: "link",
                    "styling-mode": "text",
                    onClick: _ctx.onDeschideDocAsociatPopup
                  }, null, 8, ["text", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.areDocumentTip && _ctx.document.Document)
                ? (_openBlock(), _createBlock(_component_DxButton, {
                    key: 3,
                    icon: "remove",
                    hint: "Elimină legătura cu documentul asociat",
                    "styling-mode": "text",
                    onClick: _ctx.onEliminaDocumentAsociat
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.areDocumentTip && _ctx.document.Document)
                ? (_openBlock(), _createBlock(_component_DxButton, {
                    key: 4,
                    text: "Preia linii",
                    icon: "import",
                    "styling-mode": "text",
                    disabled: _ctx.isPreluandProduse,
                    onClick: _ctx.onPreiaLiniiDinDocumentAsociat
                  }, null, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxButton, {
                icon: "print",
                hint: "Tipărire PDF",
                "styling-mode": "text",
                onClick: _ctx.onTiparirePDF
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                icon: "share",
                hint: "Partajează",
                "styling-mode": "text",
                onClick: _ctx.shareClicked
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Editează document",
                icon: "edit",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-edit-document')))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "dx-icon dx-icon-group doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "doc-meta-label" }, "Partener", -1)),
                _createElementVNode("span", {
                  class: "doc-meta-value doc-meta-value--partener",
                  title: _ctx.document.Partener
                }, _toDisplayString(_ctx.document.Partener || '—'), 9, _hoisted_11)
              ])
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "dx-icon dx-icon-event doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "doc-meta-label" }, "Data", -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.document.Data)), 1)
              ])
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "dx-icon dx-icon-tags doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "doc-meta-label" }, "Tip", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.document.Tip), 1)
              ])
            ]),
            (_ctx.document.Scadenta)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "dx-icon dx-icon-clock doc-meta-icon" }, null, -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "doc-meta-label" }, "Scadență", -1)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.document.Scadenta)), 1)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.document.Curs && _ctx.document.Valuta && _ctx.document.Valuta !== 'RON')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "dx-icon dx-icon-money doc-meta-icon" }, null, -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, "Curs " + _toDisplayString(_ctx.document.Valuta), 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.document.Curs?.toLocaleString('ro-RO', { minimumFractionDigits: 4 })), 1)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "doc-meta-spacer" }, null, -1)),
            (_ctx.cursEUR !== null || _ctx.cursUSD !== null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "doc-meta-label" }, "Cursuri BNR", -1)),
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.cursEUR !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "doc-curs-simbol" }, "EUR", -1)),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatRO(_ctx.cursEUR)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cursUSD !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "doc-curs-simbol" }, "USD", -1)),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatRO(_ctx.cursUSD)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("div", {
                    class: "doc-meta-divider",
                    style: {"margin":"0 10px"}
                  }, null, -1))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.document.Total || _ctx.document.Valoare)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_ctx.document.Valoare)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "doc-totals-label" }, "Fără TVA", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.document.Valoare.toLocaleString('ro-RO', { minimumFractionDigits: 2 })) + " " + _toDisplayString(_ctx.document.Valuta || 'RON'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.document.Valoare && _ctx.document.Total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                    : _createCommentVNode("", true),
                  (_ctx.document.Total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "doc-totals-label doc-totals-label--main" }, [
                          _createElementVNode("i", {
                            class: "dx-icon dx-icon-money",
                            style: {"font-size":"11px","vertical-align":"middle","margin-right":"3px"}
                          }),
                          _createTextVNode(" Total ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.document.Total.toLocaleString('ro-RO', { minimumFractionDigits: 2 })) + " " + _toDisplayString(_ctx.document.Valuta || 'RON'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.document)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createVNode(_component_GridDocumentLinii, {
            ref: "gridLiniiRef",
            document: _ctx.document,
            onRefreshDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh-document', $event))),
            onHasLiniiChanged: _ctx.onHasLiniiChanged,
            onDirtyCountChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('dirty-count-change', $event))),
            onOpenEtichete: _ctx.onOpenEtichete
          }, null, 8, ["document", "onHasLiniiChanged", "onOpenEtichete"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.document === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[30] || (_cache[30] = [
          _createElementVNode("i", { class: "dx-icon-warning" }, null, -1),
          _createElementVNode("p", null, "Vă rugăm să selectați un document pentru a vedea detaliile.", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.document)
      ? (_openBlock(), _createBlock(_component_PopupEtichete, {
          key: 3,
          document: _ctx.document,
          "linie-id": _ctx.eticheteLinieId,
          visible: _ctx.isEticheteVisible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEticheteVisible = $event))
        }, null, 8, ["document", "linie-id", "visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isPreiaComenziPopupVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isPreiaComenziPopupVisible = $event)),
      width: 600,
      height: 450,
      "show-title": true,
      title: "Alegeți comenzile pentru preluare produse",
      "drag-enabled": true,
      "hide-on-outside-click": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.dsComenzi,
          "key-expr": "Id",
          height: "100%",
          "show-borders": true,
          onSelectionChanged: _ctx.onComenziProiectSelectionChanged
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSelection, {
              mode: "multiple",
              "show-check-boxes-mode": "always"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Cod",
              caption: "Cod",
              width: "140"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "DataComenzii",
              caption: "Data",
              "data-type": "date",
              format: "yyyy-MM-dd",
              width: "120"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Nume",
              caption: "Denumire"
            })
          ]),
          _: 1
        }, 8, ["data-source", "onSelectionChanged"]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_DxButton, {
              text: "Importă selectate",
              type: "success",
              "styling-mode": "outlined",
              disabled: _ctx.comenziProiectSelectate.length === 0 || _ctx.isPreluandProduse,
              onClick: _ctx.onImportaComenziSelectate
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              "styling-mode": "outlined",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPreiaComenziPopupVisible = false))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isDocAsociatPopupVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDocAsociatPopupVisible = $event)),
      width: 600,
      height: 480,
      "show-title": true,
      title: "Selectează documentul asociat",
      "drag-enabled": true,
      "hide-on-outside-click": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxTextBox, {
          value: _ctx.docAsociatSearchText,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.docAsociatSearchText) = $event)),
          placeholder: "Caută după număr document...",
          onValueChanged: _ctx.onCautaDocumenteAsociate
        }, null, 8, ["value", "onValueChanged"]),
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.docAsociatCandidati,
          "key-expr": "Id",
          height: "360px",
          "show-borders": true,
          onRowDblClick: _ctx.onSelecteazaDocumentAsociat
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxColumn, {
              "data-field": "Numar",
              caption: "Număr",
              width: "140"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Data",
              caption: "Data",
              "data-type": "date",
              format: "yyyy-MM-dd",
              width: "120"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Tip",
              caption: "Tip"
            })
          ]),
          _: 1
        }, 8, ["data-source", "onRowDblClick"]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              "styling-mode": "outlined",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDocAsociatPopupVisible = false))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}